const bps = [0,600,900,1200,1536]
const bpLabels = ['xs','sm','md','lg','xl']
const mq = bps.reduce((prev,bp,index)=>({...prev,[bpLabels[index]]:`@media (min-width: ${bp}px)`}),{})

export default mq